var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDdhLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5824 10.1403C23.5824 15.7433 19.0719 20.2805 13.5018 20.2805C10.2728 20.2805 7.38681 18.7478 5.55029 16.3726C5.77229 16.3929 6.00438 16.4132 6.23646 16.4132C7.58862 16.4132 8.84996 15.9767 9.86913 15.2358C10.8883 15.9767 12.1496 16.4132 13.5018 16.4132C16.9427 16.4132 19.7278 13.6117 19.7278 10.1403C19.7278 6.66881 16.9427 3.87745 13.5018 3.87745C12.1496 3.87745 10.8883 4.31392 9.86913 5.0549C8.84996 4.31392 7.58862 3.87745 6.23646 3.87745C6.00438 3.87745 5.78238 3.8876 5.56038 3.91805C7.3969 1.53271 10.2728 0 13.5018 0C19.0719 0 23.5824 4.53723 23.5824 10.1403Z",
    fill: "#0F62FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4624 10.1404C12.4624 12.2416 11.4432 14.0991 9.86903 15.2359C8.29488 14.0991 7.26562 12.2416 7.26562 10.1404C7.26562 8.03929 8.29488 6.18177 9.86903 5.04492C11.4432 6.18177 12.4624 8.03929 12.4624 10.1404Z",
    fill: "#0F62FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42076 10.1405C3.42076 12.4853 4.21793 14.6473 5.5499 16.3729C2.43187 16.0278 0 13.3684 0 10.1405C0 6.91272 2.43187 4.25332 5.5499 3.9082C4.21793 5.62362 3.42076 7.79581 3.42076 10.1405Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdhLogo);
export default __webpack_public_path__ + "static/media/ddh-logo.e04667e9f28f2b65318bc59c63718f21.svg";
export { ForwardRef as ReactComponent };